<template>
  <div class="employee-view">
    <page-header :title="employeeLabel">
      <template #actions>
        <icon-button
          icon="list"
          tooltip="Audit Log"
          @click="$router.push(`/audit?employee=${$route.params.id}`)"
        />
      </template>
    </page-header>

    <section v-if="loaded">
      <div class="widget">
        <align class="header" flex>
          <h3 class="secondary-font">
            Verify Cards
          </h3>
        </align>

        <div class="grid">
          <stat-item
            size="xlarge"
            success
            label="Progress"
            :value="$filters.number(employee.progressCount)"
          />

          <stat-item
            size="xlarge"
            success
            label="Review"
            :value="$filters.number(employee.reviewCount)"
          />

          <stat-item
            size="xlarge"
            success
            label="Back to Progress Weekly"
            :value="$filters.number(employee.weeklyMovedBackCount)"
          />

          <stat-item
            size="xlarge"
            success
            label="Back to Progress Monthly"
            :value="$filters.number(employee.monthlyMovedBackCount)"
          />
        </div>
      </div>

      <div class="widget">
        <align class="header" flex>
          <h3 class="secondary-font">
            Cards Added
          </h3>
        </align>

        <div class="grid">
          <stat-item
            size="xlarge"
            success
            label="Added Weekly"
            :value="$filters.number(employee.weeklyAddedCount)"
          />

          <stat-item
            size="xlarge"
            success
            label="Added Monthly"
            :value="$filters.number(employee.monthlyAddedCount)"
          />

          <stat-item
            size="xlarge"
            success
            label="Total Cards"
            :value="$filters.number(employee.totalAddedCount)"
          />
        </div>
      </div>

      <div class="widget">
        <align class="header" flex>
          <h3 class="secondary-font">
            Pending Sales
          </h3>
        </align>

        <div class="grid">
          <stat-item
            size="xlarge"
            success
            label="Reviewed Monthly"
            :value="$filters.number(employee.pendingSalesCount)"
          />

          <stat-item
            size="xlarge"
            success
            label="Average Lifespan of Pending"
            :value="$filters.duration(employee.pendingSalesDuration)"
          />
        </div>
      </div>
    </section>

    <spinner v-else />
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';

import { indexService } from '@/services';

import StatItem from '@cardladder/shared/components/StatItem';

export default {
  components: {
    StatItem,
  },

  data() {
    return {
      loaded: false,
      employee: {},
    };
  },

  created() {
    this.load();
  },

  computed: {
    employeeId() {
      return this.$route.params.id;
    },

    employeeLabel() {
      if (this.employee?.label) {
        return this.employee.label;
      }

      return 'Employee';
    },
  },

  methods: {
    async load() {
      this.loaded = false;

      try {
        const report = await indexService.getReport();

        this.employee = report.employees[this.employeeId];
      } catch (e) {
        this.$toasted.error('Error loading employee');
        Sentry.captureException(e);
      }

      this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.employee-view {
  @include container;
  min-height: 100%;
}

.widget {
  margin-bottom: $gp * 2;

  .grid {
    @include grid-panel;
  }

  .header {
    margin: 0 0 $gp;
  }

  h3 {
    margin: 0;
  }
}
</style>
